import React from 'react';
import { Rate, RateProps } from 'antd';
import { CustomComponentProps } from '../types';

export interface MyRateProps extends CustomComponentProps, Omit<RateProps, 'onChange' | 'value'> {
  count?: number;
  allowHalf?: boolean;
  allowClear?: boolean;
  character?: React.ReactNode;
  tooltips?: string[];
}

const MyRate: React.FC<MyRateProps> = ({
  value,
  onChange,
  disabled,
  readonly,
  count = 5,
  allowHalf = false,
  allowClear = true,
  character,
  tooltips,
  ...rest
}) => {
  const handleChange = (newValue: number) => {
    if (!readonly && onChange) {
      onChange(newValue);
    }
  };

  return (
    <Rate
      value={value}
      onChange={handleChange}
      disabled={disabled || readonly}
      count={count}
      allowHalf={allowHalf}
      allowClear={allowClear}
      character={character}
      tooltips={tooltips}
      {...rest}
    />
  );
};

export default MyRate;
